export default {
  created() {
    const permittedRoles = ['supervisor', 'admin', 'super_admin'];
    if (this.user && permittedRoles.indexOf(this.user.role) === -1) {
      this.$router.replace({ name: 'error' });
    }
  }
};
